import { render, staticRenderFns } from "./modalDuplicarImagen.vue?vue&type=template&id=5dc14374&"
import script from "./modalDuplicarImagen.vue?vue&type=script&lang=js&"
export * from "./modalDuplicarImagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports